// extracted by mini-css-extract-plugin
export default {"container":"GPAWvQtVzwNc6MuTPQKk"};